<div class="container">

  <h4 class="form-page-name">
    EBB Contractor Materials
  </h4>


  @if ((currentContact?.isContractor && currentContact?.femaTrained)) {
    <div
      class="retrofit-form-text">
      <div class="retrofit-form-text">
        <div [innerHTML]="textContractorMaterialEbbComplete"></div>
      </div>
    </div>
  } @else {
    <div class="retrofit-form-text">
      <div [innerHTML]="textContractorMaterialEbbIncomplete"></div>
    </div>
    <div fxLayout="row" fxLayout.lt-md="column wrap" fxLayoutGap="25px">
      <div fxFlex='100%'>
        <a mat-stroked-button color="primary"
          (click)="redirectToEBBTraining()">
          GO TO BRACE BOLT COURSE
        </a>
      </div>
    </div>
  }

  <h4 class="form-page-name ess-content">
    ESS Contractor Materials
  </h4>


  @if ((currentContact?.isContractor && currentContact?.essFemaTrained)) {
    <div
      class="retrofit-form-text .ess-content">
      <div class="retrofit-form-text">
        <div [innerHTML]="textContractorMaterialEssComplete"></div>
      </div>
    </div>
  } @else {
    <div class="retrofit-form-text">
      <div [innerHTML]="textContractorMaterialEssIncomplete"></div>
    </div>
    <div fxLayout="row" fxLayout.lt-md="column wrap" fxLayoutGap="25px">
      <div fxFlex='100%'>
        <a mat-stroked-button color="primary"
          (click)="redirectToESSTraining()">
          GO TO SOFT STORY COURSE
        </a>
      </div>
    </div>
  }
  <div class="emr-content">
    <h4 class="form-page-name emr-content">
      EMR Contractor Materials
    </h4>


    @if ((currentContact?.isContractor && currentContact?.emrFemaTrained)) {
      <div
        class="retrofit-form-text .emr-content">
        <div class="retrofit-form-text">
          <div [innerHTML]="textContractorMaterialEmrComplete"></div>
        </div>
      </div>
    } @else {
      <div class="retrofit-form-text">
        <div [innerHTML]="textContractorMaterialEmrIncomplete"></div>
      </div>
      <div fxLayout="row" fxLayout.lt-md="column wrap" fxLayoutGap="25px">
        <div fxFlex='100%'>
          <a mat-stroked-button color="primary"
            (click)="redirectToEMRTraining()">
            GO TO MULTI-UNIT COURSE
          </a>
        </div>
      </div>
    }
  </div>
  <div style="min-height: 50px;"></div>

</div>
